module.exports = __webpack_public_path__ + "static/media/gyeongwon_middle_logo.1f6305aa.png";